import React, { useEffect } from 'react'

import PropTypes from 'prop-types'

import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'
import useCustomTheme from 'hooks/useCustomTheme'

import helpers from 'helpers'

const CompanyFragilitiesPdf = ({
  exportingPdf,
  setExportingPdf,
  fragilities,
  shouldCreateVersion,
  refresh,
}) => {
  const snackbar = useSnackbar()
  const { customTheme, customLogo } = useCustomTheme()
  const { userCompany } = useAuth()

  const customStyles = customTheme?.palette?.layout

  useEffect(() => {
    if (exportingPdf) {
      if (fragilities) {
        helpers.reports.fragilities.exportPdf(
          userCompany,
          customStyles,
          customLogo,
          fragilities,
          setExportingPdf,
          snackbar,
          shouldCreateVersion,
          refresh,
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportingPdf])

  return <></>
}

CompanyFragilitiesPdf.propTypes = {
  setExportingPdf: PropTypes.func,
  fragilities: PropTypes.array,
}

CompanyFragilitiesPdf.defaultProps = {
  setExportingPdf: () => {},
}

export default CompanyFragilitiesPdf
